import { render, staticRenderFns } from "./Inscriptions-pasarela-paypal-comp.vue?vue&type=template&id=23efdfb0&scoped=true&"
import script from "./Inscriptions-pasarela-paypal-comp.vue?vue&type=script&lang=js&"
export * from "./Inscriptions-pasarela-paypal-comp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23efdfb0",
  null
  
)

export default component.exports